// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DuTW5","colBig":"styles_colBig__9WaXS","colSmall":"styles_colSmall__3nphc"};